<template>
  <HttpContentView :endpoint="utilities.path('communities/@/modules', communityId)" v-model:reload="reload">
    <template v-slot:content="{ data }">
      <div class="row g-4">
        <div class="col-12 col-sm-6 col-xl-4" v-for="item in data" :key="item.key">
          <div class="card">
            <div class="card-body">
              <div class="d-flex flex-column g-3">
                <div class="d-flex align-items-center g-3">
                  <i :class="item.icon" class="fa-2x fa-fw"></i>
                  <h3 class="text-white mb-0">{{ item.name }}</h3>
                </div>
                <div v-if="item.description.length > 0" class="text-muted" style="font-size: 0.9em">
                  {{ item.description }}
                </div>
                <HttpFormView :endpoint="utilities.path('communities/@/modules/@', communityId, item.key)" method="put" @success="reload = true">
                  <template v-slot:form="{ content, submit, loading }">
                    <div class="position-relative">
                      <CheckboxInputView color="primary" :value="item.enabled" :title="translate('enabled')" @update:value="content.enabled = $event; submit()"/>
                      <SpinnerView :active="loading" color="primary"/>
                    </div>
                  </template>
                </HttpFormView>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </HttpContentView>
</template>

<script setup>
import {HttpContentView, utilities, HttpFormView, CheckboxInputView, SpinnerView} from "@niftybit/vue";
import {ref} from "vue";

defineProps({
  communityId: String
});

const reload = ref(false);

</script>